import React from 'react';
import Footer from '../../Layout/Footer';

const ShippingPolicy = () => {
    return (
        <>
            {/* Navigation */}
            <nav>
                <div className="nav-container">
                    <h1 className="logo">Raivens Technologies</h1>
                    <div className="nav-buttons">
                        <a href="/login" className="button button-primary">Login</a>
                        <a href="/login" className="button button-primary">Register</a>
                    </div>
                </div>
            </nav>
            <div className='common-wrap'>
                <div className='container'>
                    <h2 className='section-title mb-4'><strong>Shipping Policy</strong></h2>
                    <div className='content'>
                        <p><strong>Last Updated: 18-03-2025</strong></p>
                        <p>At Raivens Technologies Pvt. Ltd., we are committed to providing you with fast, reliable, and efficient shipping services. No matter where you are, we strive to ensure that your order reaches you quickly and securely.</p>
                        
                        <h3>Order Processing & Shipping Timeline</h3>
                        <h4>1. Processing Time</h4>
                        <ul>
                            <li>Orders are sent to the manufacturer for dispatch within 2 hours after confirmation.</li>
                            <li>The manufacturer and courier service process the orders within 12-24 hours before shipping.</li>
                        </ul>
                        
                        <h4>2. Shipping Time</h4>
                        <ul>
                            <li>Standard Shipping: 1-2 business days (varies based on location).</li>
                            <li>Expedited Shipping: 0-1 business days (faster delivery within India).</li>
                            <li>Overnight Shipping: Same-day delivery within 2 working hours (orders must be placed before 12 PM local time).</li>
                        </ul>
                        <p>Note: Delivery times may be affected by factors beyond our control, such as public holidays, weather conditions, or courier delays.</p>
                        
                        <h3>Shipping Methods & International Shipping</h3>
                        <h4>Domestic Shipping (India)</h4>
                        <ul>
                            <li>Standard Shipping: Reliable and cost-effective, with an estimated delivery of 1-2 business days.</li>
                            <li>Expedited Shipping: Faster delivery within 0-1 business days.</li>
                            <li>Overnight Shipping: Same-day delivery in select cities for orders placed before 12 PM local time.</li>
                        </ul>
                        
                        <h4>International Shipping</h4>
                        <p>We offer shipping to select international destinations. However, additional time may be required for:</p>
                        <ul>
                            <li>Customs clearance</li>
                            <li>International duties and taxes (to be borne by the customer)</li>
                        </ul>
                        <p>Shipping rates and estimated delivery times for international orders will be calculated at checkout.</p>
                        <p><strong>Customs & Duties:</strong> Raivens Technologies Pvt. Ltd. is not responsible for customs duties, taxes, or additional charges imposed during or after shipping. Customers are responsible for any tariffs, taxes, or customs fees applicable in their respective countries.</p>
                        
                        <h3>Shipping Restrictions</h3>
                        <ul>
                            <li><strong>P.O. Boxes:</strong> Due to carrier limitations, we do not ship to P.O. Boxes. If a P.O. Box address is provided, we will contact you to request an alternate delivery address, which may cause shipping delays.</li>
                            <li><strong>Remote Locations:</strong> Some locations may require extra time for delivery due to logistical constraints.</li>
                        </ul>
                        
                        <h3>Order Tracking & Updates</h3>
                        <p><strong>Track Your Order:</strong> Once your order has been shipped, we will send a shipping confirmation email/SMS with a tracking link to monitor your shipment in real time.</p>
                        <p>For tracking issues, delays, or concerns, contact our customer support.</p>
                        
                        <h3>Shipping Issues & Support</h3>
                        <p>If your order has not arrived within the expected timeframe, or if you have encountered any issues, please reach out to our Customer Service Team for assistance.</p>
                        <p><strong>Company Address:</strong></p>
                        <p>Raivens Technologies Pvt. Ltd.<br />Sonwa Road, Near Power House,<br />Tonk, Rajasthan - 304001, India</p>
                        <p><strong>Shipping Address:</strong></p>
                        <p>Raivens Technologies Pvt. Ltd.<br />Plot No 4, Laxmi Vilas, Choudhary Colony, Sawai Madhopur Road, Tonk, Rajasthan, India - 304001</p>
                        <p>📞 WhatsApp Support: <a href="tel:+918696606662">+91 8696606662</a></p>
                        <p>📧 Email Support: <a href="mailto:info@raivens.com">info@raivens.com</a></p>
                        <p>We are here to help you with any shipping-related inquiries and to ensure a smooth delivery experience. 🚀</p>
                    </div>
                </div>
            </div>
            <Footer />
        </>
    );
};

export default ShippingPolicy;
